import 'swiper/swiper-bundle.css';

import { Button, Icon, Typography } from '@smartgift/frontend-toolkit';
import qs from 'qs';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SwiperSlide } from 'swiper/react';

import { Swiper } from '@hero/atoms';
import { HomeTopCategoriesSkeletons } from '@hero/components/skeletons';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetCSEntries } from '@hero/services/content-stack-service/hooks';

import * as S from './style';

export function HomeTopCategories() {
  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const swiper = useRef();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    data: topCategories,
    isSuccess,
    isFetching
  } = useGetCSEntries({
    entryCode: 'sgb_admin_home_top_categories'
  });

  const params = {
    spaceBetween: 12,
    slidesPerView: 'auto',
    slidesPerGroup: 3,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    }
  };

  const sortedTopCategories = topCategories?.entries?.sort((a, b) => a.order - b.order);

  if ((isSuccess && !sortedTopCategories?.length) || isFetching) {
    return null;
  }

  return (
    <S.HomeTopCategoriesWrapper>
      <Typography variant="subtitle3Bold" style={{ textAlign: 'center' }}>
        {t('popularCategories')}
      </Typography>
      <S.HomeTopCategories>
        <S.NavigationButton
          color="secondary"
          variant="outlined"
          ref={navigationPrevRef}
          style={{ transform: 'rotate(180deg)', marginRight: 4 }}
        >
          <Icon name="next" />
        </S.NavigationButton>

        {isFetching ? (
          <S.CategorySkeleton>
            <HomeTopCategoriesSkeletons />
          </S.CategorySkeleton>
        ) : (
          <Swiper ref={swiper} {...params}>
            {sortedTopCategories?.map(category => (
              <SwiperSlide
                style={{
                  width: 100,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                key={category.category_id}
              >
                <S.CategoryItem
                  as="div"
                  onClick={() => {
                    const search = qs.stringify({
                      categoryIds: [category.category_id]
                    });
                    navigate(`${ROUTE_PATHS.GIFT_CATALOG}?${search}`);
                  }}
                >
                  <S.CategoryImage src={category.image?.url} height="80px" width="80px" />
                  <S.CategoryName variant="body2Bold">{category?.name}</S.CategoryName>
                </S.CategoryItem>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        <S.NavigationButton
          style={{ marginLeft: 4 }}
          color="secondary"
          variant="outlined"
          ref={navigationNextRef}
        >
          <Icon name="next" />
        </S.NavigationButton>
      </S.HomeTopCategories>
      <S.ActionWrapper>
        <Button size="sm" onClick={() => navigate(ROUTE_PATHS.GIFT_CATALOG)}>
          {t('seeAllItems')}
        </Button>
      </S.ActionWrapper>
    </S.HomeTopCategoriesWrapper>
  );
}
